module.exports = __webpack_public_path__ + "img/instructions_2.78578702.png";